/* Ekimall mobile menu — close + left-swipe (v258)
   v257 swipe OK; header X still failed on iOS/Horizon.
   Root cause: tapping summary while open often toggles <details> closed
   BEFORE the click handler runs, so isOpen() is already false and our
   early-return skipped close — then Horizon on:click="/toggle" saw
   isOpen=false and called open() again (re-open race). Swipe only called
   closeMenu(), so it worked.

   v258 fix:
   - pointerdown capture while open: preventDefault + stopImmediate + close
     (suppresses the synthetic click / toggle reopen path)
   - click capture with closeArmed / still-open: force close, never reopen
   - toggle capture: if closeArmed and details re-opens, force close
   - left-swipe unchanged (dx <= -60, horizontal-dominant)
*/
(function () {
  var DETAILS_ID = 'Details-menu-drawer-container';
  var SWIPE_MIN = 60;
  var AXIS_RATIO = 1.2; /* |dx| must exceed |dy| * ratio */
  var closeArmed = false;
  var closeArmedTimer = null;

  function detailsEl() {
    return document.getElementById(DETAILS_ID);
  }

  function isOpen(d) {
    return !!(d && (d.open || d.classList.contains('menu-open')));
  }

  function armClose() {
    closeArmed = true;
    if (closeArmedTimer) clearTimeout(closeArmedTimer);
    closeArmedTimer = setTimeout(function () {
      closeArmed = false;
      closeArmedTimer = null;
    }, 450);
  }

  function closeMenu() {
    var d = detailsEl();
    if (!d) return;
    var host = d.closest('header-drawer');
    try {
      if (host && typeof host.close === 'function') host.close();
    } catch (e) {}
    /* Immediate fallback — do not wait onAnimationEnd (transform:none nukes anim) */
    d.classList.remove('menu-open');
    d.removeAttribute('open');
    var summary = d.querySelector(':scope > summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
    document.documentElement.removeAttribute('data-ekimall-drawer-open');
    if (document.documentElement.hasAttribute('scroll-lock')) {
      document.documentElement.removeAttribute('scroll-lock');
    }
  }

  function summaryFromEvent(e) {
    var t = e.target;
    if (!t || !t.closest) return null;
    /* Match header hamburger/X only — not nested submenu summaries */
    return t.closest(
      '#' + DETAILS_ID + ' > summary, #' + DETAILS_ID + ' > summary.header__icon--menu, summary.header__icon--menu.header__icon--summary'
    );
  }

  /* pointerdown while open: close + arm guard (kills iOS/Horizon reopen race) */
  document.addEventListener(
    'pointerdown',
    function (e) {
      var summary = summaryFromEvent(e);
      if (!summary) return;
      var d = detailsEl();
      if (!isOpen(d)) return;
      armClose();
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      closeMenu();
    },
    true
  );

  /* click: if armed or still open, force-close and block Horizon /toggle open() */
  document.addEventListener(
    'click',
    function (e) {
      var summary = summaryFromEvent(e);
      if (!summary) return;
      var d = detailsEl();
      if (!closeArmed && !isOpen(d)) return; /* normal open path */
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      closeMenu();
      armClose();
    },
    true
  );

  /* If something re-opens during the armed window, slam it shut */
  document.addEventListener(
    'toggle',
    function (e) {
      var t = e.target;
      if (!t || t.id !== DETAILS_ID) return;
      if (closeArmed && t.open) {
        closeMenu();
      }
    },
    true
  );

  /* Left-swipe to close on the open drawer panel */
  var startX = 0;
  var startY = 0;
  var tracking = false;
  var axisLocked = ''; /* 'h' | 'v' | '' */

  function onTouchStart(e) {
    var d = detailsEl();
    if (!isOpen(d)) return;
    var touch = e.changedTouches && e.changedTouches[0];
    if (!touch) return;
    var drawer = d.querySelector('.menu-drawer');
    if (!drawer) return;
    var t = e.target;
    if (!t || !drawer.contains(t)) return;
    startX = touch.clientX;
    startY = touch.clientY;
    tracking = true;
    axisLocked = '';
  }

  function onTouchMove(e) {
    if (!tracking) return;
    var touch = e.changedTouches && e.changedTouches[0];
    if (!touch) return;
    var dx = touch.clientX - startX;
    var dy = touch.clientY - startY;
    if (!axisLocked) {
      if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
      axisLocked = Math.abs(dx) > Math.abs(dy) * AXIS_RATIO ? 'h' : 'v';
    }
    if (axisLocked === 'v') {
      tracking = false;
      return;
    }
  }

  function onTouchEnd(e) {
    if (!tracking) return;
    tracking = false;
    if (axisLocked === 'v') return;
    var touch = e.changedTouches && e.changedTouches[0];
    if (!touch) return;
    var dx = touch.clientX - startX;
    var dy = touch.clientY - startY;
    if (dx <= -SWIPE_MIN && Math.abs(dx) > Math.abs(dy) * AXIS_RATIO) {
      armClose();
      closeMenu();
    }
  }

  document.addEventListener('touchstart', onTouchStart, { passive: true, capture: false });
  document.addEventListener('touchmove', onTouchMove, { passive: true, capture: false });
  document.addEventListener('touchend', onTouchEnd, { passive: true, capture: false });
  document.addEventListener('touchcancel', function () { tracking = false; }, { passive: true });
})();
